<app-header-title>
  <span title>اعتماد طلبات الإجازات</span>
</app-header-title>

<div class="publicsetting" style="padding: 0rem 3rem;">

  <!-- Bulk Action Bar -->
  <div style="
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 0;
    margin-bottom: 10px;">

    <span style="color: #555; font-size: 14px;">
      تم تحديد <strong>{{ selectedRequests.length }}</strong> طلب
    </span>

    <dx-button
      text="اعتماد / رفض المحدد"
      type="success"
      icon="check"
      [disabled]="selectedRequests.length === 0"
      (onClick)="openBulkApprovalPopup()">
    </dx-button>

  </div>

  <!-- DataGrid -->
  <dx-data-grid
    [dataSource]="vacationRequests"
    [showBorders]="true"
    [showRowLines]="true"
    [showColumnLines]="true"
    [rowAlternationEnabled]="true"
    [hoverStateEnabled]="true"
    [rtlEnabled]="true"
    (onSelectionChanged)="onSelectionChanged($event)">

    <!-- ✅ Multi-Select -->
    <dxo-selection
      mode="multiple"
      [showCheckBoxesMode]="'always'">
    </dxo-selection>
    <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
    <dxo-paging [pageSize]="10"></dxo-paging>
    <dxo-pager
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[10, 20, 50]"
      [showInfo]="true">
    </dxo-pager>

    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-header-filter [visible]="true"></dxo-header-filter>

    <dxi-column dataField="id"          caption="رقم الطلب"   [width]="100" alignment="center"></dxi-column>
    <dxi-column dataField="employeeName" caption="اسم الموظف"  [width]="220" alignment="center"></dxi-column>
    <dxi-column dataField="employeeId"  caption="رقم الموظف"  [width]="120" alignment="center"></dxi-column>
    <dxi-column dataField="holidayName" caption="نوع الإجازة" [width]="150" alignment="center"></dxi-column>

    <dxi-column
      dataField="startDate"
      caption="من تاريخ"
      dataType="date"
      format="dd/MM/yyyy"
      [width]="130">
    </dxi-column>

    <dxi-column
      dataField="endDate"
      caption="إلى تاريخ"
      dataType="date"
      format="dd/MM/yyyy"
      [width]="130">
    </dxi-column>

    <dxi-column dataField="numberOfDaysRequested" caption="عدد الأيام" [width]="100" alignment="center"></dxi-column>
    <dxi-column dataField="vacationReson"         caption="السبب"      [minWidth]="200"></dxi-column>

    <!-- 🟢 إضافة عمود المرفق هنا -->
    <dxi-column
      caption="المرفق"
      [width]="120"
      alignment="center"
      cellTemplate="attachmentTemplate">
    </dxi-column>

    <dxi-column
      dataField="requestStatus"
      caption="الحالة"
      [width]="130"
      alignment="center"
      cellTemplate="statusTemplate">
    </dxi-column>

    <dxi-column
      dataField="timeOfRequest"
      caption="وقت الطلب"
      dataType="datetime"
      format="dd/MM/yyyy HH:mm"
      [width]="160">
    </dxi-column>

    <!-- 🟢 Template المرفق -->
    <div *dxTemplate="let cell of 'attachmentTemplate'">
      <!-- إذا كان يوجد مسار للمرفق نعرض زر التنزيل/الفتح -->
      <dx-button
        *ngIf="cell.data.attachmentPath"
        icon="download"
        hint="عرض / تحميل المرفق"
        type="default"
        stylingMode="outlined"
        (onClick)="downloadAttachment(cell.data.attachmentPath)">
      </dx-button>

      <!-- إذا لم يكن هناك مرفق -->
      <span *ngIf="!cell.data.attachmentPath" style="color: #aaa; font-size: 12px;">
        لا يوجد
      </span>
    </div>

    <!-- Status Template -->
    <div *dxTemplate="let cell of 'statusTemplate'">
      <span [style.color]="getStatusColor(cell.value)" style="font-weight: bold;">
        {{ getStatusText(cell.value) }}
      </span>
    </div>

  </dx-data-grid>


  <!-- ✅ Bulk Approval Popup -->
  <dx-popup
    [(visible)]="showApprovalPopup"
    [showTitle]="true"
    title="اعتماد / رفض الطلبات المحددة"
    [dragEnabled]="false"
    [closeOnOutsideClick]="false"
    [showCloseButton]="true"
    [width]="520"
    [height]="'auto'"
    [rtlEnabled]="true">

    <div *dxTemplate="let data of 'content'" style="padding: 20px;">

      <!-- Summary -->
      <div style="
        background: #e8f5e9;
        border: 1px solid #a5d6a7;
        border-radius: 8px;
        padding: 12px 16px;
        margin-bottom: 20px;">
        <strong>عدد الطلبات المحددة: {{ selectedRequests.length }}</strong>
        <div style="margin-top: 8px; font-size: 13px; color: #444; max-height: 80px; overflow-y: auto;">
          <span *ngFor="let r of selectedRequests; let last = last">
            طلب #{{ r.id }} ({{ r.employeeName }})<span *ngIf="!last"> ، </span>
          </span>
        </div>
      </div>

      <!-- Form -->
      <dx-form [formData]="approvalModel" labelLocation="top">

        <!-- Status -->
        <dxi-item
          dataField="requestStatus"
          editorType="dxSelectBox"
          [editorOptions]="{
            dataSource: requestStatusList,
            valueExpr: 'id',
            displayExpr: 'nameAr',
            searchEnabled: false
          }">
          <dxo-label text="حالة الطلب"></dxo-label>
        </dxi-item>

        <!-- Refuse Reason — تظهر بس لو status = مرفوض -->
        <dxi-item
          dataField="refuseReason"
          editorType="dxTextArea"
          [visible]="approvalModel.requestStatus === 2"
          [editorOptions]="{ height: 90 }">
          <dxo-label text="سبب الرفض"></dxo-label>
        </dxi-item>

      </dx-form>

      <!-- Actions -->
      <div style="display: flex; gap: 12px; margin-top: 20px; justify-content: flex-end;">
        <dx-button
          text="إلغاء"
          type="normal"
          [disabled]="isSubmitting"
          (onClick)="closeApprovalPopup()">
        </dx-button>
        <dx-button
          text="تأكيد"
          type="success"
          [disabled]="isSubmitting"
          (onClick)="submitApproval()">
        </dx-button>
      </div>

    </div>
  </dx-popup>

</div>